import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_secure/projects/$projectId/settings/")({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/projects/$projectId/settings/general",
      params: { projectId: params.projectId },
      search: {},
    });
  },
});
